import React from 'react'
import Link from 'gatsby-link'

const SecondPage = () => (
  <div>
    <h1>404!</h1>
  </div>
)

export default SecondPage
